<template>
  <v-container fluid>
    <div class="row">
      <v-col cols="12" sm="12" md="8" lg="8">
        <Paychecks />
      </v-col>
    </div>
  </v-container>
</template>

<script>
import Paychecks from '../home/components/PayChecks.vue'

export default {
  name: 'Payckecks',
  components: {
    Paychecks,
  },
}
</script>
